import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  textPart: {
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 16,
  },
  suggestionRefund: {
    margin: 0,
    color: theme.colors.light.freshPowder,
  },
  amountRefund: {
    color: theme.colors.orange.orange,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
